<template>
    <b-modal
            :ref="modalId"
            lazy
            title-tag="h2"
            title="Warning"
            footer-class="d-flex"
            id="modalConfirmType"
    >
        <p>
            Warning: Changing this item type from Administrative Fee to other type category will remove this item from other's item fee.
        </p>
        <p>
            To proceed, type <strong>permanently change</strong> in the field
            below
            <b-form-group label-cols="0" label-for="name">
                <b-input
                        v-model.trim="textConfirmation"
                        class="form-control"
                        name="textConfirmation"
                        autocomplete="off"
                />
            </b-form-group>
        </p>
        <div slot="modal-footer" class="w-100">
            <modal-footer
                    okTitle="Proceed"
                    :isLoading="isLoading"
                    @ok-action="proceed"
                    @cancel-action="cancel"
                    :isDisabled="!enableProceedButton"
            />
        </div>
    </b-modal>
</template>

<script type="text/javascript">
export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {},
    data() {
        return {
            isLoading: false,
            modalId: "modalConfirmType",
            textConfirmation: ''
        };
    },
    computed: {
        enableProceedButton() {
            return this.textConfirmation.toLowerCase() === `permanently change`;
        }
    },
    methods: {
        open() {
            this.$refs[this.modalId].show();
        },
        /**
         * @method proceed
         * @description Proceed the item update with make a change to uses base price
         */
        proceed() {
            this.$emit("proceed", true);
            this.$refs[this.modalId].hide();
        },
        /**
         * @method cancel
         * @description Cancelling the item update
         */
        cancel() {
            this.$refs[this.modalId].hide();
            this.$emit("cancel", false);
        }
    }
};
</script>
<style scoped>
#modalConfirmType___BV_modal_outer_{
    z-index: 104000 !important;
}
</style>
